import { useId } from 'react'
import skyArt from './assets/card-sky.webp'

// The ernd card as on ernd.io since Malcolm's restyle (2026-10-27, malcolm-ernd src/components/shared/sky-card-face.tsx):
// a dusk sky, clear blue into purple with thin light clouds, a brushed-silver chip and the white wordmark bottom-left,
// a light top sheen and a thin bright rim. Same proportions and chip placement as the old card photo (1200 x 746).
// Decorative: the page around it says what it is.

function Chip() {
  const id = useId()
  return (
    <svg className="e-skycard-chip" viewBox="0 0 100 80" aria-hidden="true">
      <defs>
        <linearGradient id={`${id}-metal`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#f3f2f8" />
          <stop offset="0.45" stopColor="#cfcddd" />
          <stop offset="0.7" stopColor="#e4e2ee" />
          <stop offset="1" stopColor="#b7b4c8" />
        </linearGradient>
        <linearGradient id={`${id}-shine`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffffff" stopOpacity="0.55" />
          <stop offset="0.5" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>
      </defs>
      <rect x="0.75" y="0.75" width="98.5" height="78.5" rx="13" fill={`url(#${id}-metal)`} />
      <g fill="none" stroke="#8f8ca6" strokeOpacity="0.55" strokeWidth="1.4" strokeLinejoin="round">
        <path d="M34 0.75V20L40 26V54L34 60V79.25" />
        <path d="M66 0.75V20L60 26V54L66 60V79.25" />
        <path d="M0.75 27H34M0.75 53H34M66 27H99.25M66 53H99.25" />
        <path d="M40 40H60" />
      </g>
      <rect x="0.75" y="0.75" width="98.5" height="78.5" rx="13" fill={`url(#${id}-shine)`} />
      <rect x="0.75" y="0.75" width="98.5" height="78.5" rx="13" fill="none" stroke="#8f8ca6" strokeOpacity="0.6" strokeWidth="1.5" />
    </svg>
  )
}

export function SkyCard({ className = '' }: { className?: string }) {
  return (
    <div className={`e-skycard ${className}`} aria-hidden="true">
      <img src={skyArt} alt="" width={1200} height={746} decoding="async" />
      <div className="e-skycard-sheen" />
      <Chip />
      <span className="e-skycard-word">ernd</span>
      <div className="e-skycard-rim" />
    </div>
  )
}
